module.exports = __webpack_public_path__ + "static/media/imgProposal02.995a1187.png";